import { render, staticRenderFns } from "./HistoricalInventoryReport.vue?vue&type=template&id=fe40f350"
import script from "./HistoricalInventoryReport.vue?vue&type=script&lang=js"
export * from "./HistoricalInventoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports